export const dietTagsData = [
  {
    name: 'WEIGHT LOSS',
    id: 1,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/WEIGHT+LOSS.JPG',
    description: [
      {
        title: 'Czym się wyróżnia ten wariant?',
        description:
          'Wiele osób rozpoczyna swoją przygodę z cateringiem dietetycznym ze względu na chęć redukcji masy ciała. Dieta odchudzająca będzie dobrym rozwiązaniem dla każdego, komu zależy na zdrowym kształtowaniu nawyków żywieniowych oraz na efektywnym osiąganiu celu, jakim jest redukcja masy ciała. Ten wariant jest możliwy do zamówienia w różnych opcjach kaloryczności, dlatego z łatwością dobierzemy energetyczność diety do własnych potrzeb.',
      },
    ],
  },
  {
    name: 'STANDARD',
    id: 2,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/STANDARD.jpg',
    description: [
      {
        title: 'Co to za wariant?',
        description:
          'Dietę standardową znajdziemy w ofercie niemalże każdego cateringu dietetycznego. Nie obejmuje żadnych wykluczeni, choć niekiedy można je dodatkowo wybrać. Charakteryzuje się dużym urozmaiceniem, a zawarte w niej posiłki na pewno nas nie znudzą. Jest to doskonałe rozwiązanie dla osób, które chciałyby zadbać o swoje zdrowie, ale brakuje im czasu na wykonywanie zakupów oraz gotowanie.',
      },
    ],
  },
  {
    name: 'GLUTEN FREE',
    id: 3,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/GLUTEN+FREE.JPG',
    description: [
      {
        title: 'Czym jest gluten?',
        description:
          'Tą nazwę niektórzy kojarzą głównie z pieczywem, ale czy to jest jego jedyne źródło? Gluten jest mieszaniną białek znajdujących się w pszenicy (gliadyna), życie (sekalina) i jęczmieniu (hordeina). W owsie znajduje się awenina i ta substancja nie wykazuje takiego działania. Niestety to zboże jest bardzo często zanieczyszczone glutenem. Aby żywność mogła być uznana za bezglutenową, może zawierać nie więcej niż 20 mg glutenu w 1 kg końcowego produktu.',
      },
    ],
  },
  {
    name: 'SPORT',
    id: 4,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/SPORT.JPG',
    description: [
      {
        title: 'Czym wyróżnia się ten wariant?',
        description:
          'Cateringi dietetyczne stworzyły specjalną opcję dla osób, które są aktywne fizycznie. Dzięki prawidłowemu odżywieniu możliwe jest osiąganie lepszych wyników sportowych, bardziej efektywnej regeneracji mięśni i utrzymaniu odpowiedniej sylwetki. Gdy podejmujemy się intensywnego wysiłku, takiego jak np. ciężkie treningi siłowe, długodystansowy bieg, czy wielogodzinna jazda na rowerze, to warto przygotować swój organizm, abyśmy byli w stanie wykonać swoje cele z dobrym samopoczuciem.',
      },
    ],
  },
  {
    name: 'VEGETARIAN',
    id: 6,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/VEGETARIAN.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Dieta wegetariańska w cateringu dietetycznym obejmuje eliminację mięsa, ryb i owoców morza. Dozwolone są jednak produkty mleczne oraz jajka. Na zamówienie tego wariantu decydują się osoby, które pragną zmniejszyć ilość spożywanych produktów odzwierzęcych, nie lubią mięsa i ryb, albo chciałyby zacząć odżywiać się bardziej roślinnie. Niekiedy jest to dobre rozwiązanie dla tych, którzy mają alergię na ryby lub czują się ociężale po zjedzeniu potraw mięsnych.',
      },
    ],
  },
  {
    name: 'DASH',
    id: 7,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/DASH.JPG',
    description: [
      {
        title: 'Dla kogo zalecana jest ta dieta?',
        description:
          'Na nadciśnienie tętnicze cierpi aż 40% osób powyżej 25 roku życia i aż 30% Polaków nie jest świadomych swojej choroby. Leczenie nadciśnienia tętniczego obejmuje nie tylko terapię lekową, ale również zmianę stylu życia i dążenie do zwiększenia aktywności fizycznej, utrzymywania prawidłowej masy ciała oraz stosowanie prawidłowo zbilansowanej diety.',
      },
    ],
  },
  {
    name: 'DETOX',
    id: 8,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/DETOX.JPG',
    description: [
      {
        title: 'Czym są detoksy sokowe?',
        description:
          'W ostatnich latach detoksy, posty kilkudniowe i diety sokowe cieszą się dużą popularnością. Wiele osób decyduje się na nie w celu pobudzenia redukcji masy ciała, oczyszczenia organizmu i poprawy samopoczucia. Ze względu na poszerzające się zainteresowanie tym sposobem żywienia, niektóre cateringi dietetyczne wprowadziły taki wariant do swojej oferty.',
      },
    ],
  },
  {
    name: 'DIABETIC',
    id: 9,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/DIABETIC.JPG',
    description: [
      {
        title: 'Dla kogo polecana?',
        description:
          'Taki rodzaj diety pudełkowej został stworzony z myślą o osobach, które cierpią na cukrzycę. Odpowiednie odżywianie jest nieodłącznym elementem terapii i bez jego wdrożenia, uregulowanie glikemii może być bardzo trudne nawet z wykorzystaniem leków. Na dietę cukrzycową z cateringu dietetycznego decydują się osoby, którym zależy na rozwinięciu swojej wiedzy o tym jak powinny wyglądać ich posiłki oraz na racjonalnym odżywianiu się każdego dnia.',
      },
    ],
  },
  {
    name: 'FISH FREE',
    id: 10,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/FISH+FREE.JPG',
    description: [
      {
        title: 'Co jest wykluczane?',
        description:
          'Dieta bez ryb jest skierowana do osób, które chcą całkowicie wykluczyć ten składnik swojej diety ze względu na preferencje żywieniowe jak i na alergię. Zazwyczaj cateringi dietetyczne tak komponują posiłki, aby nie zawierały one także owoców morza. Nie znajdziemy w nich także produktów przygotowywanych na bazie ryb – np. sosu rybnego, czy pasty krewetkowej.',
      },
    ],
  },
  {
    name: 'GLUTEN LACTOSE FREE',
    id: 11,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/GLUTEN+LACTOSE+FREE.JPG',
    description: [
      {
        title: 'Co jest eliminowane w tej diecie?',
        description:
          'W przypadku tego wariantu ze wszystkich posiłków wykluczane są źródła glutenu, który znajdziemy w niektórych zbożach: w pszenicy, jęczmienie i życie. Niekiedy owies jest także zanieczyszczony glutenem, dlatego zaleca się wybieranie tylko takich produktów z jego udziałem, które będą posiadały certyfikat produktu bezglutenowego. Dodatkowo eliminowane są wszystkie składniki będące źródłem laktozy, czyli cukru mlecznego.',
      },
    ],
  },
  {
    name: 'HASHI',
    id: 12,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/HASHI.JPG',
    description: [
      {
        title: 'Czym jest Hashimoto?',
        description:
          'Hashimoto to choroba o podłożu autoimmunizacyjnym, która jest najczęstszą przyczyną niedoczynności tarczycy. Zauważa się, że występuje 10 nawet do 20 razy częściej wśród kobiet niż wśród mężczyzn. Wariant diety z cateringu dietetycznego dla osób z chorobą Hashimoto może być stosowany również przez chorych na niedoczynność tarczycy o innym podłożu (np. niedoczynnością prostą), ponieważ obejmuje wiele ważnych aspektów, które wpierają pracę tego narządu.',
      },
    ],
  },
  {
    name: 'PERSONAL',
    id: 13,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/PERSONAL.JPG',
    description: [
      {
        title: 'Czym jest dieta indywidualna?',
        description:
          'Pomimo, że cateringi dietetyczne oferują coraz więcej różnorodnych wariantów diet, to niekiedy nasze potrzeby, cele żywieniowe i preferencje wymagają bardziej spersonalizowanego podejścia. Indywidualna dieta pudełkowa jest spełnieniem marzeń wielu z nas – każdego dnia możemy otrzymywać posiłki, które doskonale wpisują się w nasze dietetyczne założenia, obejmują również nasze eliminacje żywieniowe oraz pomagają jeszcze efektywniej w realizowaniu zamierzonych celów.',
      },
    ],
  },
  {
    name: 'KETO',
    id: 14,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/KETO.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Dieta ketogeniczna z charakteryzuje się zawartością bardzo niewielkiej ilości węglowodanów i opiera się głównie na źródłach tłuszczu oraz białka. Ta dieta ma na celu zmianę procesów metabolicznych, które przebiegają w naszym organizmie. Przed jej zastosowaniem należy jednak być w pełni świadomym tego, że wdrożenie diety ketogenicznej wiąże się z większą pracą dla nerek i wątroby, dlatego te dwa organy mogą być nieco obciążone.',
      },
    ],
  },
  {
    name: 'KIDS',
    id: 15,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/KIDS.JPG',
    description: [
      {
        title: 'Czym jest zdrowa dieta u dziecka?',
        description:
          'Żywienie dzieci jest szczególnie istotne, ponieważ wpływa na ich prawidłowy rozwój, samopoczucie, zdolność do koncentracji i zapamiętywania. W czasie wzrostu organizmu niektóre niedobory pokarmowe mogą mieć wieloletnie konsekwencje. Warto pamiętać też o tym, że kształtowanie zdrowych nawyków żywieniowych w czasie wzrostu będzie dla naszego dziecka bardzo pomocne, gdy staną się osobami dorosłymi.',
      },
    ],
  },
  {
    name: 'LACTOSE FREE',
    id: 16,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/WEIGHT+LOSS.JPG',
    description: [
      {
        title: 'Czym jest nietolerancja laktozy?',
        description:
          'Laktoza to dwucukier, który znajduje się w mleku i jego przetworach. Po jej spożyciu w naszym organizmie fizjologicznie wydziela się enzym – laktaza, który ma za zadanie rozbić ją na dwa pojedyncze cząsteczki cukru. Niektóre osoby nie są jednak zdolne do wydzielania go w wystarczającej ilości (hipolaktazja), co skutkuje niepełnym strawieniem laktozy W przypadku występowania nietolerancji laktozy zaleca się wprowadzenie diety ze znacznym ograniczeniem lub wykluczeniem tego dwucukru.',
      },
    ],
  },
  {
    name: 'LOW IG',
    id: 18,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/LOW+IG.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Cateringi dietetyczne coraz częściej poszerzają swoje oferty o dietę o niskim indeksie glikemicznym. Szerząca się popularność tego rodzaju odżywiania wynika z tego, że osoby zmagające się z zaburzeniami gospodarki węglowodanowej otrzymują zalecenia od lekarzy, aby nie tylko przyjmować zapisane leki, ale również stosować jadłospis, który nie będzie powodował dużych skoków glukozy we krwi i pomoże w redukcji ryzyka wystąpienia powikłań tych schorzeń, np. cukrzycy.',
      },
    ],
  },
  {
    name: 'MOM',
    id: 19,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/MOM.JPG',
    description: [
      {
        title: 'Dla kogo polecany jest ten wariant?',
        description:
          'Taki rodzaj diety jest skierowany dla kobiet w ciąży oraz mam karmiących piersią lub po zakończeniu okresu laktacji. Dietetycy układający jadłospisy do tego wariantu dbają o to, aby zapotrzebowanie na wszystkie najważniejsze składniki było w pełni pokryte. Pamiętajmy o tym, że zarówno w czasie ciąży jak i podczas karmienia piersią, niezbędne jest spożywanie większej ilości białka, niektórych witamin i minerałów.',
      },
    ],
  },
  {
    name: 'OFFICE',
    id: 21,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/OFFICE.JPG',
    description: [
      {
        title: 'Na czym polega ta dieta?',
        description:
          'Zanim pojawiły się na rynku cateringi dietetyczne, to jedynym ratunkiem dla osób, które nie zabrały niczego do jedzenia ze sobą do pracy był pobliski sklep lub zamówienie obiadu z dostawą do biura. Od jakiegoś czasu dieta pudełkowa zaczyna się także wpisywać w taką formę, a Lunch do biura to wariant, który zainteresuje wszystkich aktualnie zamawiających z restauracji.',
      },
    ],
  },
  {
    name: 'PALEO',
    id: 22,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/PALEO.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Dieta paleo powstała w oparciu o to, jak wyglądał jadłospis ludzi żyjących w paleolicie. Taki wariant cieszy się dużym zainteresowaniem, szczególnie wśród tych, którzy nie dysponują wystarczającą ilością czasu, aby gotować swoje posiłki każdego dnia. Na jego wybór decydują się zarówno osoby pragnące zredukować masę ciała, jak i te, które mają na celu utrzymać aktualną sylwetkę. Dzięki wysokiej zawartości białka, z dietą paleo łatwiej jest o uregulowanie nadmiernego uczucia głodu.',
      },
    ],
  },
  {
    name: 'SAMURAI',
    id: 23,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/PERSONAL.JPG',
    description: [
      {
        title: 'Czym jest dieta samuraja?',
        description:
          'Twórcą tej diety jest Nate Miyaki, który postanowił zmodyfikować założenia diety paleo, w taki sposób, aby była bardziej dostosowana do potrzeb osób aktywnych fizycznie. Zauważył bowiem, że przy paleolitycznym sposobie żywienia nieco trudniej jest o szybkie uzupełnianie zapasów glikogenu w mięśniach po treningu oraz odczuwa się mniejszą siłę przy wykonywaniu ćwiczeń. Takie negatywne efekty są spowodowane niską zawartością węglowodanów w diecie paleo i między innymi ten element został zmodyfikowany w tej diecie.',
      },
    ],
  },
  {
    name: 'VEGAN',
    id: 25,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/GLUTEN+FREE.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Dieta wegańska charakteryzuje się wykluczeniem wszystkich produktów pochodzenia zwierzęcego – nie tylko mięsa i ryb, ale również nabiału oraz jajek. Komponowana jest w oparciu o roślinne źródła białka, takie jak soja i przetwory sojowe (np. tofu), soczewicę, ciecierzycę, groch i fasolę. Coraz więcej osób decyduje się na rezygnację z mięsa zamawiając dietę wegetariańską, ale weganizm również zaczyna być bardzo popularnym sposobem odżywiania.',
      },
    ],
  },
  {
    name: 'VEGE AND FISH',
    id: 26,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/HASHI.JPG',
    description: [
      {
        title: 'Czym jest ten wariant?',
        description:
          'Ten wariant charakteryzuje się tym, że z jadłospisu jest eliminowane mięso, tak jak w standardowej diecie wegetariańskiej, ale dozwolone są ryby. To rozwiązanie cieszy się dużą popularnością z uwagi na to, że częste spożywanie ryb, szczególnie tłustych, morskich wiąże się z wieloma korzyściami zdrowotnymi. W pudełkach z cateringu dietetycznego przy tej opcji znajdziemy przede wszystkim bardzo urozmaicone posiłki, oparte na różnorodnych źródła białka (jajka, nabiał, ryby, rośliny strączkowe) oraz tłuszczu (oleje roślinne, orzechy, nasiona, tłuste ryby morskie). Jeśli decydujemy się na dietę pudełkową w celu poprawy swojego zdrowia, redukcji masy ciała, czy zdobycia pomysłów na ciekawe potrawy, to ten wariant z pewnością sprosta naszym oczekiwaniom.',
      },
    ],
  },
  {
    name: 'HOME',
    id: 27,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/HOME.JPG',
    description: [
      {
        title: 'Czym jest dieta domowa w cateringu dietetycznym?',
        description:
          'Dieta domowa to wariant, który łączy tradycyjne i znane wszystkim potrawy z różnorodnością. Wszyscy, którzy tęsknią za naleśnikami, domowymi wędlinami, ciastem czekoladowym, czy nawet za sałatką gyros, będą z pewnością zadowoleni właśnie z diety domowej. Dania w niej zawarte są znane i lubiane, dlatego śmiało możemy ją wypróbować całą rodziną – zarówno dzieci, dorośli, jak i osoby starsze, które cenią tradycję na talerzu, znajdą w niej coś dla siebie.',
      },
    ],
  },
  {
    name: 'SIRTFOOD',
    id: 28,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/SIRTFOOD.JPG',
    description: [
      {
        title: 'Czym jest dieta sirtfood?',
        description:
          'Dieta sirtfood to wariant diety pudełkowej, który składa się z 4 etapów i jego wybór zalecany jest osobom, które dążą do redukcji masy ciała i jednocześnie chcą zadbać o swoje zdrowie oraz wygląd. Założenia diety sirtfood zostały opracowane przez dwóch brytyjskich specjalistów ds. żywienia. Dieta sirtuinowa polega na stosowaniu jadłospisu w oparciu o tzw. produkty sirtuinowe, czyli takie, które sprzyjają zwiększeniu produkcji sirtuin.',
      },
    ],
  },
  {
    name: 'LOW CARB',
    id: 29,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/PALEO.JPG',
    description: [
      {
        title: 'Czym jest dieta low carb?',
        description:
          'Dieta niskowęglowodanowa, zwana dietą low carb, polega na znacznym ograniczaniu tego składnika. Gdy kaloryczność diety pokrywana jest z mniej niż 26% z węglowodanów, to wtedy mowa o low carb. W diecie standardowej zawartość tego makroskładnika sięga 45-65% energii, zatem low carb będzie się znacznie różniło od standardowego wariantu diety pudełkowej. ',
      },
    ],
  },
  {
    name: 'VEGE AND FRUIT',
    id: 30,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/dietly-diets/VEGE+AND+FRUIT.JPG',
    description: [
      {
        title: 'Czym jest post warzywno-owocowy?',
        description:
          'Post warzywno-owocowy to wariant cateringu dietetycznego, który stał się w ostatnim czasie niezwykle popularny i jest swego rodzaju programem odchudzającym. Składa się z dwóch etapów i pierwszy z nich jest dość restrykcyjny, ponieważ dozwolone są tylko warzywa i owoce, a całodzienny jadłospis zawiera ok. 400-600 kcal. Drugi etap to rozszerzenie diety o inne produkty, takie jak zboża, nabiał, orzechy, ziarna.',
      },
    ],
  },
  {
    name: 'FODMAP',
    id: 31,
    imgUrl:
      'https://miscellaneous-images.s3.eu-central-1.amazonaws.com/foodmap.png',
    description: [
      {
        title: 'Czym jest dieta low FODMAP?',
        description:
          'Dieta low FODMAP to model żywieniowy stworzony dla osób zmagających się z zespołem jelita drażliwego i SIBO. Stosuje się go w oparciu o założenia autorów, czyli Monash University. Polega na ograniczaniu węglowodanów łatwo fermentujących (FODMAP - Fermentujące Oligo- Di- i Monosacharydy oraz Poliole) w celu zminimalizowania dolegliwości jelitowych.',
      },
    ],
  },
  {
    name: 'INTERMITTENT_FASTING',
    id: 32,
    imgUrl: '',
    description: [
      {
        title: 'Czym jest dieta Intermittent Fasting',
        description:
          'Dieta Intermittent Fasting to sposób odżywiania, który polega na ograniczeniu czasu przyjmowania posiłków i wydłużeniu okresu postu. Podczas tej diety, spożywasz jedzenie tylko w określonych godzinach, zwanych oknem żywieniowym, a następnie pozostajesz na czczo przez resztę dnia. Intermittent Fasting może pomóc w utracie wagi, poprawie zdrowia metabolicznego i redukcji stanów zapalnych w organizmie.',
      },
    ],
  },
];
